import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-visit',
  imports: [RouterLink],
  templateUrl: './visit.html',
  styleUrl: './visit.scss',
})
export class Visit {}
